import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CARTBUTTONBLOCK_LEGACY_FIELD_ORDER = [];

const {
  cartButtonBlockDescriptor: _generatedCartButtonBlockDescriptor,
  cartButtonBlockBlocDefinition,
  cartButtonBlockDashboardLayout,
  cartButtonBlockConfig,
  cartButtonBlockResolveConfig,
  cartButtonBlockProperties,
} = doodBlockConfig(
  {
    name: "Cart button",
    componentType: 'CartButtonBlockComponent',
    category: 'cart',
    description: "Cart button.",
    keywords: [],
    sharedFields: {}
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [],
          },
        ],
      },
    ],
  })
);

export function cartButtonBlockDescriptor(): IBlockDescriptor;
export function cartButtonBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartButtonBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartButtonBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartButtonBlockDescriptor, cartButtonBlockProperties, fieldOrder);
}

export {
  cartButtonBlockBlocDefinition,
  cartButtonBlockDashboardLayout,
  cartButtonBlockProperties,
  cartButtonBlockConfig,
  cartButtonBlockResolveConfig,
};

export type CartButtonBlockConfig = typeof cartButtonBlockConfig;
